/* Lookup — the page-head lede and the provisioning notice, in the shell's language (13-15).
 * The ask-or-search panel itself keeps its own stylesheet (a verbatim copy shared with
 * FieldLink). */

/* The page-head lede (mock .pagehead p). */
.intro {
  margin: 8px 0 28px;
  max-width: 66ch;
  font-size: 15px;
  color: var(--gray);
}

/* A gentle amber notice: the feature is not switched on yet, nothing is broken. */
.advisorBanner {
  margin: 0 0 20px;
  max-width: 66ch;
  padding: 12px 16px;
  border: 1px solid var(--amber-line);
  border-radius: 12px;
  background: var(--amber-soft);
  color: var(--amber-dark);
  font-size: 14px;
}

/* Our policy library couldn't be read for this account (ISS-229 b, 13.1-10): the same calm
 * amber notice. A fault to tell Andy about, not an alarm. */
.libraryNotice {
  margin: 0 0 20px;
  max-width: 66ch;
  padding: 12px 16px;
  border: 1px solid var(--amber-line);
  border-radius: 12px;
  background: var(--amber-soft);
  color: var(--amber-dark);
  font-size: 14px;
}

/* 13-25: open a register record by its reference. */
.openRecord {
  margin: 0 0 24px;
  max-width: 66ch;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.openLabel {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text);
}

.openRow {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.openInput {
  flex: 1 1 220px;
  min-height: 44px;
  padding: 0.625rem 0.75rem;
  font: inherit;
  font-size: var(--font-size-base);
  color: var(--color-text);
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
}

.openInput:focus {
  outline: none;
  border-color: var(--color-border-focus);
  box-shadow: 0 0 0 2px rgba(104, 50, 141, 0.15);
}

.openButton {
  min-height: 44px;
  padding: 0 20px;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-inverse);
  background: var(--teal);
  border: 0;
  border-radius: var(--radius-full);
  cursor: pointer;
}

.openButton:hover {
  background: var(--teal-dark);
}

.openButton:focus-visible {
  outline: 2px solid var(--color-border-focus);
  outline-offset: 2px;
}

.openRefused {
  margin: 0;
  padding-left: 10px;
  font-size: 13px;
  color: var(--amber-dark);
  border-left: 3px solid var(--amber);
}
